// Basic
import React from 'react';
import ReactDOM from 'react-dom';

// Application
import App from './App';

// Render
ReactDOM.render(
  <App />,
  document.getElementById('root'));
